<template>
  <div class="container">
    <div class="container m15">
      <div class="container"
           style="height: 40px; line-height: 40px;color: #999">
        <span class="font_link_fw">
          <router-link :to="{name: 'home'}">首页</router-link>
        </span> &nbsp;&nbsp;>&nbsp;&nbsp;
        <span class="productHref">专业服务</span> &nbsp;&nbsp;>&nbsp;&nbsp;
        <span style="color:#1D65A8 ; cursor:pointer"
              v-if="menuIndex>-1 && serviceMenuList[menuIndex]"
              @click="choose(menuIndex)">{{serviceMenuList[menuIndex].name}}</span>
        <span style="color:#1D65A8 ; cursor:pointer"
              v-if="twoMenuIndex>-1">&nbsp;&nbsp;>&nbsp;&nbsp;<b>{{this.serviceData[this.twoMenuIndex].name}}</b></span>
      </div>
    </div>
    <!-- 一级类目 -->
    <div class="container"
         style="background-color: #ffffff;">
      <div style="height:40px;margin: 10px 0px;">
        <span class="yjlm"
              :class="{yjlmactive : menuIndex == index}"
              v-for="(item,index) in serviceMenuList"
              :key="item.id"
              @click="choose(index)">{{item.name}}</span>
      </div>
    </div>
    <!-- 二级 -->
    <div class="container"
         style="background-color: #ffffff;"
         v-if="serviceData.length>0 ">
      <div style="height:40px;margin: 10px 0px;">
        <span class="yjlm ejlm"
              :class="{ejlmac : twoMenuIndex == -1}"
              @click="choose(menuIndex)">全部</span>
        <span class="yjlm ejlm"
              :class="{ejlmac : twoMenuIndex == index}"
              v-for="(item,index) in serviceData"
              :key="index"
              @click="chooseTwo(index)">
          {{item.name}}
        </span>
      </div>
    </div>
    <div class="goods-box"
         v-if="serviceDataList.length">
      <!-- <el-row :gutter="16" > -->
      <div class="goods-show-info"
           v-for="(item, index) in serviceDataList"
           :key="index"
           :class="{'goods-show-infor':(index+1)%4===0}"
           @click="jumpToDetail(item.name, item.serviceId)">
        <div class="goods-show-img"
             style="height: 151px;">
          <img :src="item.thumbnailUrl || '../../../assets/img/占位图.png'"
               class="ssimg"
               :alt="item.name" />
        </div>
        <div class="goods-show-detail">
          <div style="width:100%;"
               class="overell">
            {{item.name || ''}}<br>
            <span class="overell"
                  :title="item.desc">{{item.desc || ''}}</span>
          </div>
        </div>
      </div>
      <!-- </el-row> -->
    </div>
    <div style="text-align:center"
         v-else>
      <img src='@/assets/img/good/noGood.png'
           alt="暂无数据">
    </div>
  </div>
</template>

<script>
// import { professionalServicesDetail } from '@/utils/eventTracking'
export default {
  name: 'serviceList',
  data () {
    return {
      // 服务一级数据
      serviceMenuList: [],
      menuIndex: 0,
      // 服务二级数据
      serviceData: [],
      twoMenuIndex: -1,
      // 服务三级数据
      serviceDataList: []
    }
  },
  computed: {
    title () {
      return this.$route.query.title
    },
    title1 () {
      return this.$route.query.title1
    }
  },
  watch: {
    title (val) {
      this.updataData()
    }
  },
  methods: {
    // 点击一级菜单
    choose (index) {
      this.menuIndex = index
      this.serviceData = this.serviceMenuList[index] && this.serviceMenuList[index].children ? this.serviceMenuList[index].children : []
      this.twoMenuIndex = -1
      // this.twoMenuIndex = this.serviceData.length ? 0 : -1
      let serviceDataList = []
      // if (this.twoMenuIndex > -1) {
      //   serviceDataList = this.serviceData[this.twoMenuIndex].children || []
      // }
      if (this.serviceData.length > 0) {
        this.serviceData.forEach(ser => {
          if (ser.children && ser.children.length > 0) {
            serviceDataList.push(...ser.children)
          }
        })
      }
      this.serviceDataList = serviceDataList
    },
    // 点击二级菜单
    chooseTwo (index) {
      this.twoMenuIndex = index
      this.serviceDataList = this.serviceData[index] && this.serviceData[index].children ? this.serviceData[index].children : []
    },
    // 选择二级目录,更新页面数据
    updataData () {
      let serviceData = []
      let menuIndex = -1
      let twoMenuIndex = -1
      let serviceDataList = []
      if (this.$route.query.title) {
        menuIndex = this.serviceMenuList.findIndex(item => {
          return item.name === this.$route.query.title
        })
        serviceData = menuIndex > -1 && this.serviceMenuList[menuIndex] && this.serviceMenuList[menuIndex].children ? this.serviceMenuList[menuIndex].children : []
        if (menuIndex > -1) {
          if (this.$route.query.title1) {
            twoMenuIndex = serviceData.findIndex(item => {
              return item.name === this.$route.query.title1
            })
          } else {
            twoMenuIndex = -1
          }
          if (menuIndex > -1 && twoMenuIndex === -1) {
            if (serviceData.length) {
              serviceData.forEach(ele => {
                if (ele.children && ele.children.length) {
                  serviceDataList.push(...ele.children)
                }
              })
            }
          } else if (menuIndex > -1 && twoMenuIndex > -1) {
            serviceDataList = serviceData[twoMenuIndex].children || []
          }
        }
      } else {
        menuIndex = this.serviceMenuList.length ? this.menuIndex : -1
        twoMenuIndex = -1 // this.serviceMenuList[menuIndex].children.length ? 0 : -1
        serviceData = this.serviceMenuList[menuIndex].children || []
        // if (menuIndex > -1 && twoMenuIndex > -1) {
        //   serviceDataList = serviceData[twoMenuIndex].children || []
        // }
        serviceData.forEach(item => {
          if (item.children && item.children.length > 0) {
            serviceDataList.push(...item.children)
          }
        })
        // this.serviceMenuList.forEach(parItem => {
        //   if (parItem.children && parItem.children.length > 0) {
        //     serviceData.push(...parItem.children)
        //     parItem.children.forEach(item => {
        //       if (item.children && item.children.length > 0) {
        //         serviceDataList.push(...item.children)
        //       }
        //     })
        //   }
        // })
      }
      // console.log(serviceDataList, 'serviceDataList')
      this.serviceData = serviceData
      this.menuIndex = menuIndex
      this.twoMenuIndex = twoMenuIndex
      this.serviceDataList = serviceDataList
    },
    // 获取服务数据
    getServiceData () {
      this.$store.commit('setLoadStatus', true)
      this.$request.postParam(`/front/user/home/homeService/findServiceTree`, {
        name: ''
      })
        .then(data => {
          this.serviceMenuList = data
          this.updataData()
        })
        // eslint-disable-next-line handle-callback-err
        .finally(() => {
          this.$store.commit('setLoadStatus', false)
        })
    },
    // 跳转详情
    jumpToDetail (name, id) {
      // professionalServicesDetail(name)
      let params = {
        title: this.menuIndex > -1 ? this.serviceMenuList[this.menuIndex].name : '',
        title1: this.twoMenuIndex > -1 ? this.serviceData[this.twoMenuIndex].name : '',
        key: name,
        id: id
      }
      this.$router.push({ name: 'serviceContent', query: params })
    }
  },
  created () {
    this.getServiceData()
  }
}
</script>

<style scoped>
.yjlm {
  line-height: 40px;
  color: #333;
  border-right: 2px #eee solid;
  padding: 0px 20px;
  height: 40px;
  width: auto;
  display: table;
  float: left;
}
.yjlm:hover {
  background: #1d65a8;
  color: #ffffff;
  cursor: pointer;
}
.ejlm {
  border-right: 0px !important;
}
.ejlm:hover {
  background: transparent !important;
  border-right: 0px !important;
  color: #1d65a8 !important;
}
.menu_list:hover {
  cursor: pointer;
}
.productHref {
  cursor: pointer;
  color: #333;
}
.goods-box {
  display: block;
  width: 100%;
}
.goods-box:after {
  content: "";
  display: block;
  clear: both;
}
/* ---------------商品栏开始------------------- */
.ssimg {
  width: 100%;
  height: 100%;
}
.goods-show-info {
  width: 290px;
  cursor: pointer;
  margin-right: 10px;
  margin-top: 10px;
  float: left;
  background: #fff;
  height: 232px;
}
.goods-show-infor {
  margin-right: 0px !important;
}
.goods-show-img {
  width: 100%;
  text-align: center;
  height: 217px;
}
.goods-show-price {
  margin-top: 6px;
}
.goods-show-detail {
  font-size: 12px;
  margin: 0px 0px;
  padding: 10px;
  height: 80px;
  line-height: 30px;
  border-top: 1px #eee solid;
}
.tags {
  color: #005aa0;
}
.goods-show-num {
  font-size: 12px;
  margin-bottom: 6px;
  color: #009688;
}
.goods-show-num span {
  color: #005aa0;
  font-weight: bold;
}
.goods-show-seller {
  font-size: 12px;
  color: #e4393c;
}
.goods-page {
  width: 100%;
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
}
.yjlmactive {
  background: #1d65a8;
  color: #ffffff;
  cursor: pointer;
}
.ejlmac {
  background: transparent !important;
  border-right: 0px !important;
  color: #1d65a8 !important;
}
</style>
